<template>
    <v-dialog v-model="show" no-click-animation width="500">
        <v-card>
            <v-layout class="headline grey lighten-2 pl-3 pr-2 py-2" primary-title align-center>
                <div>{{item ? $t('creator.intent') : $t('editor.intent')}}</div>
                <v-spacer></v-spacer>
                <v-btn small icon @click="close">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-layout>
            <v-card-text>
                <v-form v-model="formValid" @submit="submit" ref="form">
                    <v-text-field
                        :label="$t('name') | capitalize"
                        v-model="label"
                        :disabled="!!item"
                        :rules="[formRules.ruleRequired, validateIntentLabel]"
                    ></v-text-field>
                    <v-text-field
                        :label="$t('description') | capitalize"
                        v-model="description"
                    ></v-text-field>
                    <template v-if="sampleList.length > 0 && !item">
                        <v-layout justify-center style="font-size: 20px">
                            {{$t('sample') | capitalize}}
                        </v-layout>
                        <div style="max-height: 500px; overflow: auto">
                            <v-layout v-for="(sample, i) in sampleList" :key="i">
                                <v-text-field
                                    v-model="sample.content"
                                    :rules="formRules.required"
                                ></v-text-field>
                                <v-btn icon @click="deleteSample(i)">
                                    <v-icon>mdi-delete</v-icon>
                                </v-btn>
                            </v-layout>
                        </div>
                    </template>
                    <v-btn class="ml-0" @click="addSample" v-if="!item">Add sample</v-btn>
                    <v-layout>
                        <v-spacer></v-spacer>
                        <v-btn class="ma-0" type="submit">{{ $t('save') }}</v-btn>
                    </v-layout>
                </v-form>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
import NLP_Service from "@/services/nlp.service";
import DialogPromiseFormMixin from "@/modules/fptai/mixins/DialogPromiseFormMixin";

export default {
    name: "IntentEditor",
    mixins: [DialogPromiseFormMixin],
    data () {
        return {
            item: null,
            label: '',
            description: '',
            sampleList: []
        }
    },
    methods: {
        open (item) {
            this.item = item
            this.clearForm()
            if (this.item) {
                this.label = item.label
                this.description = item.description
            }
            this.show = true
            return new Promise((resolve, reject) => {
                this.promise = { resolve, reject }
            })
        },
        submitValidForm () {
            let model, promise, i18n
            if (this.item) {
                model = {
                    description: this.description
                }
                i18n = {
                    action: this.$t('update'),
                    item: this.$t('intent')
                }
                promise = NLP_Service.IntentService.replace(this.$route.params.scenarioId, this.item.label, model)
            } else {
                model = {
                    label: this.label,
                    description: this.description
                }
                i18n = {
                    action: this.$t('create'),
                    item: this.$t('intent')
                }
                promise = NLP_Service.IntentService.create(this.$route.params.scenarioId, model)
            }
            this.$appService.showLoading()
            promise.then(
                resultIntent => {
                    this.$appService.toastSuccess(this.$t('actionSuccessful', i18n))
                    if (this.sampleList.length > 0) {
                        let promiseList = []
                        let scenarioId = this.$route.params.scenarioId
                        for (let sample of this.sampleList) {
                            let promise = NLP_Service.SampleService.create(
                                scenarioId,
                                { content: sample.content }
                            ).then(
                                resultSample => {
                                    return NLP_Service.IntentSampleService.create(scenarioId, {
                                        intent_code: resultIntent.data.code,
                                        sample_code: resultSample.data.code
                                    }).catch(this.$appService.handleRequestError())
                                },
                                this.$appService.handleRequestError()
                            )
                            promiseList.push(promise)
                        }
                        return Promise.allSettled(promiseList).then(
                            () => {
                                this.close()
                                this.clearForm()
                                this.promise.resolve(resultIntent.data)
                            }
                        )
                    } else {
                        this.promise.resolve(resultIntent.data)
                        this.close()
                        this.clearForm()
                    }
                },
                this.$appService.handleRequestError(this.$t('actionFailed', i18n))
            ).finally(this.$appService.hideLoading)

        },
        addSample () {
            this.sampleList.push({ content: '' })
        },
        deleteSample (index) {
            this.sampleList.splice(index, 1)
        },
        clearForm () {
            this.$refs.form.reset()
            this.sampleList = []
        },
        validateIntentLabel (value) {
            return /^[a-z0-9_]+$/.test(value) || 'label should contains a-z, 0-9 and underscore'
        }
    }
}
</script>

<style scoped>

</style>
